import ESSearchService from 'lib/workperks/services/ESSearchService';
import ADSearchService from 'lib/workperks/services/ADSearchService';
const createSearchServiceWithOptions = (options) => {
    return options.location.country === 'US' ? new ADSearchService(options) : new ESSearchService(options);
};
export const createSearchServiceWithSerialization = (serializedSearchService) => {
    return serializedSearchService.location.country === 'US'
        ? ADSearchService.unserialize(serializedSearchService)
        : ESSearchService.unserialize(serializedSearchService);
};
export default createSearchServiceWithOptions;
